/* ============
 * Register checkBusiness Transformer
 * ============
 *
 * The transformer for the account setup.
 */

import Transformer from './../transformer';

export default class CheckBusinessTransformer extends Transformer {
  /**
   * Method used to transform a fetched account setup.
   *
   * @param checkBusiness The fetched account setup.
   *
   * @returns {Object} The transformed checkBusiness
   */
  static fetch(checkBusiness) {
    return {
      email: checkBusiness.email ? checkBusiness.email : '',
      businessRegistrationNumber: checkBusiness.business_registration_number ? checkBusiness.business_registration_number : '',
      businessName: checkBusiness.name ? checkBusiness.name : '',
      type: checkBusiness.business_type ? checkBusiness.business_type : '',
      address: checkBusiness.address ? checkBusiness.address : '',
      postalCode: checkBusiness.postal_code ? checkBusiness.postal_code : '',
      city: checkBusiness.city ? checkBusiness.city : '',
      country: checkBusiness.country ? checkBusiness.country : '',
      isVatRegistered: checkBusiness.is_vat_registered ? checkBusiness.is_vat_registered : '',
      isRegisteredBusinessEnterprise: checkBusiness.is_registered_business_enterprise ? checkBusiness.is_registered_business_enterprise : '',
    };
  }

  /**
   * Method used to transform a send checkBusiness
   *
   * @param checkBusiness The checkBusiness to be send
   *
   * @returns {Object} The transformed checkBusiness
   */
  static send(checkBusiness) {
    return {
      email: checkBusiness.email,
      business_registration_number: checkBusiness.businessRegistrationNumber,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/custom/checkBusiness.js